import { render } from "./WalletConnect.vue?vue&type=template&id=5ca4a77a"
import script from "./WalletConnect.vue?vue&type=script&lang=js"
export * from "./WalletConnect.vue?vue&type=script&lang=js"

import "./WalletConnect.vue?vue&type=style&index=0&id=5ca4a77a&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__